"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_SIZE_FACTOR = 22;

var DownloadIcon = function DownloadIcon(_ref) {
  var className = _ref.className,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    focusable: false,
    height: ICON_SIZE_FACTOR * size,
    role: "presentation",
    viewBox: "0 0 31.8 46",
    width: ICON_SIZE_FACTOR * size
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.8,23.8l-10.9,11L5,23.8l1.6-1.6l8.2,8.3V5H17v25.5l8.2-8.3L26.8,23.8z M5.8,41v-2.2H26V41H5.8z"
  }));
};

DownloadIcon.defaultProps = {
  className: '',
  size: 1
};
DownloadIcon.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.number
};
var _default = DownloadIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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